import { useEffect } from 'react';
import { WebGLRenderer } from '../render/WebGLRenderer';

export const useWebGL = (
  webglCanvasRef: React.RefObject<HTMLCanvasElement | null>,
  webglRendererRef: React.MutableRefObject<WebGLRenderer | null>
) => {
  useEffect(() => {
    if (webglCanvasRef.current && !webglRendererRef.current) {
        try {
            webglRendererRef.current = new WebGLRenderer(webglCanvasRef.current);
        } catch (e) {
            console.error("WebGL Initialization Failed", e);
        }
    }
  }, [webglCanvasRef]);
};
